import { defineField, defineType } from 'sanity'
import { richTextContent } from '../../data/richText'

export default defineType({
  name: 'infoBar',
  title: 'Info Bar',
  type: 'document',
  fieldsets: [
    {
      name: 'modal',
      title: 'Modal',
      options: {
        collapsed: false,
        collapsible: true,
      },
      hidden: ({ document }) => document?.displayType !== 'modal',
    },
    {
      name: 'link',
      title: 'Link',
      options: {
        collapsed: false,
        collapsible: true,
      },
      hidden: ({ document }) => document?.displayType !== 'link',
    },
  ],
  fields: [
    defineField({
      name: 'title',
      title: 'Title',
      type: 'string',
    }),
    defineField({
      name: 'enable',
      title: 'Enable',
      description: 'Allows you to toggle info bar on and off',
      type: 'boolean',
    }),
    defineField({
      name: 'displayType',
      title: 'Display Type',
      type: 'string',
      initialValue: 'modal',
      options: {
        list: [
          { title: 'Modal', value: 'modal' },
          { title: 'Link', value: 'link' },
        ],
        layout: 'radio',
      },
    }),
    defineField({
      name: 'content',
      title: 'Content',
      type: 'array',
      of: richTextContent,
      fieldset: 'modal',
      description:
        'If content is empty, info bar will not be clickable and modal will not open',
    }),
    defineField({
      name: 'buttons',
      title: 'Buttons',
      type: 'buttonList',
      fieldset: 'modal',
    }),
    defineField({
      name: 'link',
      title: 'Link',
      type: 'infoBarLink',
      fieldset: 'link',
      hidden: ({ document }) => document?.displayType !== 'link',
    }),
  ],
  preview: {
    select: {
      title: 'title',
      displayType: 'displayType',
    },
    prepare({ title = 'Untitled', displayType = 'modal' }) {
      return {
        title,
        subtitle: `Info bar (${displayType})`,
      }
    },
  },
})